import AboutUsModule from 'components/about-us/AboutUsModule';
import AboutUsSiteContainer from 'components/about-us/AboutUsSiteContainer';
import { OptionalLink } from 'components/common/OptionalLink';
import RoundedButton from 'components/RoundedButton';
import { useState } from 'react';
import ButtonComponentPreview from './button';
import DrawCountdownPreview from './draw-countdown';
import EnterFlowOrderSummaryPreview from './enter-flow-order-summary';
import EntriesAndStatsPreview from './entries-and-stats';
import ExpandySectionPreview from './expandy-section';
import InstagramFeedPreview from './instagram-feed';
import ModulesAndContainers from './modules-and-containers';
import Monthly10kGiveawayPreview from './monthly-10k-giveaway';
import MoreWaysToWinPreview from './more-ways-to-win';
import OrderConfirmationPreview from './order-confirmation';
import ProgressionBarPreview from './progression-bar';
import RadioToggleButtonPreview from './radio-toggle-button';
import TicketStackPreview from './ticket-stack';
import TreeProgressionPreview from './tree-progression';
import TypographyPreview from './typography';
import UnclaimedWeeklyDrawPrizePreview from './unclaimed-weekly-draw-prize';
import YourSubscriptionPreview from './your-subscription';
import YourWinsPreview from './your-wins';

const componentPreviews = [
  TypographyPreview,
  ModulesAndContainers,
  ButtonComponentPreview,
  RadioToggleButtonPreview,
  ExpandySectionPreview,
  ProgressionBarPreview,
  DrawCountdownPreview,
  YourSubscriptionPreview,
  TicketStackPreview,
];

const examplePreviews = [
  EntriesAndStatsPreview,
  InstagramFeedPreview,
  Monthly10kGiveawayPreview,
  MoreWaysToWinPreview,
  TreeProgressionPreview,
  YourWinsPreview,
  UnclaimedWeeklyDrawPrizePreview,
  EnterFlowOrderSummaryPreview,
];

const pagePreviews = [OrderConfirmationPreview];

const DesignSystem = () => {
  const [showAll, setShowAll] = useState(false);
  return (
    <div className="aboutUsTypographyReset hackHeadingTextAlign">
      <AboutUsModule background={'white'}>
        <AboutUsSiteContainer>
          <h1 className="aboutUsTypographyHeaderXlargeOnWhite">
            The DAYMADE design system
          </h1>
          <p>
            This page showcases the various styles and components use around the
            site. It is a work in progress. Many of the pages do not (yet) use
            the design system
          </p>

          <p>Components</p>
          <ul>
            {componentPreviews.map((ComponentPreview, index) => (
              <li key={index}>
                <OptionalLink
                  href={getDaymadeDesignSystemComponentUrl(ComponentPreview)}
                >
                  <a>{getDaymadeDesignSystemComponentName(ComponentPreview)}</a>
                </OptionalLink>
              </li>
            ))}
          </ul>
          <p>Examples of page components</p>
          <ul>
            {examplePreviews.map((ComponentPreview, index) => (
              <li key={index}>
                <OptionalLink
                  href={getDaymadeDesignSystemComponentUrl(ComponentPreview)}
                >
                  <a style={{ textDecoration: 'underline' }}>
                    {getDaymadeDesignSystemComponentName(ComponentPreview)}
                  </a>
                </OptionalLink>
              </li>
            ))}
          </ul>
          <p>Page previews</p>
          <ul>
            {pagePreviews.map((ComponentPreview, index) => (
              <li key={index}>
                <OptionalLink
                  href={getDaymadeDesignSystemComponentUrl(ComponentPreview)}
                >
                  <a style={{ textDecoration: 'underline' }}>
                    {getDaymadeDesignSystemComponentName(ComponentPreview)}
                  </a>
                </OptionalLink>
              </li>
            ))}
          </ul>
          {!showAll && (
            <p className="textAlignCenter">
              <RoundedButton rebrandDm2025 onClick={() => setShowAll(true)}>
                Show all
              </RoundedButton>
            </p>
          )}
        </AboutUsSiteContainer>
      </AboutUsModule>

      {showAll &&
        componentPreviews.map((ComponentPreview, index) => (
          <ComponentPreview key={index} />
        ))}
    </div>
  );
};

function getDaymadeDesignSystemComponentName(
  component: DaymadeDesignSystemPreviewComponent,
) {
  return (
    component.daymadeDesignSystemInfo?.name ||
    'Unnamed component, see getDaymadeDesignSystemComponentName'
  );
}

function getDaymadeDesignSystemComponentUrl(
  component: DaymadeDesignSystemPreviewComponent,
) {
  return component.daymadeDesignSystemInfo?.name
    ? '/design-system/' +
        component.daymadeDesignSystemInfo?.name
          .replace(/ /gi, '-')
          .toLowerCase()
    : undefined;
}

export interface DaymadeDesignSystemPreviewComponent {
  (): JSX.Element;
  daymadeDesignSystemInfo?: DaymadeDesignSystemPreviewComponentInfo;
}
export interface DaymadeDesignSystemPreviewComponentInfo {
  name: string;
  path?: string;
}

export default DesignSystem;
